import ModalBase from "../../../global/ModalBase"
import HeaderModal from "../../../global/headerModal"
import BackDrop from "../../../global/BackDrop"
import ControllerEditor from "./ControlledEditor"
import { useState } from "react"
import { IconButton, Tooltip, Button, Grid, AppBar, Tabs, Tab, Box } from "@material-ui/core"
import BookIcon from '@material-ui/icons/Book'
import { FPaqueteDetalleStyle } from "./styles"
import { useDispatch } from "react-redux"
import { useEffect } from "react"
import { getPaqueteDetalle, addPaqueteDetalle, actulizaPaqueteDetalle } from "../../../ducks/paqueteDetalleDuck"
import { ToastMessage } from "../../../global/ToastMessage"
function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    {children}
                </Box>
            )}
        </div>
    )
}
function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}
const FormularioModal = (props) => {
    const { open, onChange, row } = props
    const dispatch = useDispatch()
    const [load, setLoad] = useState(false)
    const [value, setValue] = useState(0)
    const [editar, setEditar] = useState(false)
    const classes = FPaqueteDetalleStyle()
    const [itinerario, setItenerario] = useState('<p><strong>Escribe aqui tu texto</strong></p>');
    const [incluye, setIncluye] = useState('<p><strong>Escribe aqui tu texto</strong></p>');
    const [noIncluye, setNoIncluye] = useState('<p><strong>Escribe aqui tu texto</strong></p>');
    const handleClose = () => {
        onChange()
        setItenerario('<p><strong>Escribe aqui tu texto</strong></p>')
        setIncluye('<p><strong>Escribe aqui tu texto</strong></p>')
        setNoIncluye('<p><strong>Escribe aqui tu texto</strong></p>')
    }
    useEffect(() => {
        setLoad(true)
        dispatch(getPaqueteDetalle({ IdPaquete: row?.IdPaquete })).then(Resposne => {
            setLoad(false)
            if (Resposne?.IdPaquete > 0) {
                setItenerario(Resposne?.Itinerario)
                setIncluye(Resposne?.Incluye)
                setNoIncluye(Resposne?.NoIncluye)
                setEditar(true)
            } else {
                setEditar(false)
            }
        })
    }, [dispatch, row?.IdPaquete, open])

    const onItinerarioValue = (value) => {
        setItenerario(value)
    }
    const onIncluyeValue = (value) => {
        setIncluye(value)
    }
    const onNoIncluyeValue = (value) => {
        setNoIncluye(value)
    }
    const onClick = () => {
        (!editar) ? onEnvio() : onActuliza()
    }
    const onEnvio = () => {
        dispatch(addPaqueteDetalle({ IdPaquete: row?.IdPaquete, Itinerario: itinerario, Incluye: incluye, NoIncluye: noIncluye })).then(Response => {
            switch (Response.status) {
                case 500:
                    ToastMessage.fire({
                        icon: "error",
                        title: "Ocurrio un problema al guardar la inforamción",
                    });
                    break;
                case 400:
                    ToastMessage.fire({
                        icon: "warning",
                        title: "<strong>Atención</strong>",
                        text: "Al menos un dato no se ha enviado, favor de llenar el registro.",
                    });
                    break;
                default:
                    handleClose();
                    ToastMessage.fire({
                        icon: "success",
                        title: "Ingreso Correcto",
                    });
                    break;
            }
        })
    }
    const onActuliza = () => {
        dispatch(actulizaPaqueteDetalle({ IdPaquete: row?.IdPaquete, Itinerario: itinerario, Incluye: incluye, NoIncluye: noIncluye })).then(Response => {
            switch (Response.status) {
                case 500:
                    ToastMessage.fire({
                        icon: "error",
                        title: "Ocurrio un problema al guardar la inforamción",
                    });
                    break;
                case 400:
                    ToastMessage.fire({
                        icon: "warning",
                        title: "<strong>Atención</strong>",
                        text: "Al menos un dato no se ha enviado, favor de llenar el registro.",
                    });
                    break;
                default:
                    handleClose();
                    ToastMessage.fire({
                        icon: "success",
                        title: "Ingreso Correcto",
                    });
                    break;
            }
        })
    }
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    return (
        <ModalBase classes={classes} open={open} onClose={handleClose}>
            <HeaderModal
                handleClose={handleClose}
                titulo={`Detalle para el paquete: ${row?.Nombre}`}
            />
            <AppBar position="static">
                <Tabs value={value} onChange={handleChange} aria-label="simple tabs example">
                    <Tab label="Itinerario" {...a11yProps(0)} />
                    <Tab label="Incluye" {...a11yProps(1)} />
                    <Tab label="No Incluye" {...a11yProps(2)} />
                </Tabs>
            </AppBar>
            <TabPanel value={value} index={0}>
                <ControllerEditor onValue={onItinerarioValue} content={itinerario} />
            </TabPanel>
            <TabPanel value={value} index={1}>
                <ControllerEditor onValue={onIncluyeValue} content={incluye} />
            </TabPanel>
            <TabPanel value={value} index={2}>
                <ControllerEditor onValue={onNoIncluyeValue} content={noIncluye} />
            </TabPanel>

            <BackDrop open={load} />
            <Grid container className={classes.containerSpacing}>
                <Grid item xs={12} className={classes.modalBotonesCenter}>
                    <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        className={classes.modalBoton}
                        onClick={onClick}
                    >
                        {editar ? "Actualizar" : "Guardar"}
                    </Button>
                </Grid>
            </Grid>
        </ModalBase>
    )
}

const FPaqueteDetalle = (props) => {
    const { row } = props
    const [open, setOpen] = useState(false)
    const onClick = () => {
        setOpen(!open)
    }
    return (
        <div>
            <Tooltip title="Detalle">
                <IconButton
                    aria-label="Detalle"
                    onClick={onClick}
                >
                    <BookIcon />
                </IconButton>
            </Tooltip>
            <FormularioModal open={open} onChange={onClick} row={row} />
        </div>
    )
}
export default FPaqueteDetalle